<div class="tabs-root">
  @if(showOptions()){
  <div class="tabs-list" role="tablist" aria-label="Tabs">
    <ng-content select="app-tab-options"></ng-content>
    <div class="tabs-baseline"></div>
    <div
      class="tabs-indicator"
      [style.width.%]="indicatorWidth()"
      [style.left.%]="indicatorLeft()"
    ></div>
  </div>
  }
  <div class="tabs-panels">
    <ng-content select="app-tab-panels"></ng-content>
  </div>
</div>
